/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumModelSchema } from "./albumModelSchema.ts";
import { authorTypeEnumSchema } from "./authorTypeEnumSchema.ts";
import { fileModelSchema } from "./fileModelSchema.ts";
import { trackModelSchema } from "./trackModelSchema.ts";
import { z } from "zod";

export const authorInfoModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"nickname": z.string().describe("Псевдоним"),
"avatar": z.lazy(() => fileModelSchema).describe("Аватар").nullable().nullish(),
"contactInfo": z.string().describe("Контактная информация").nullable().nullish(),
"description": z.string().describe("Описание").nullable().nullish(),
"types": z.array(z.lazy(() => authorTypeEnumSchema).describe("Тип авторов. \n\r\n1 - Исполнитель \n\r\n2 - Подкастер \n\r\n3 - Проповедник \n\r\n4 - Чтец \n<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Artist</b>: Исполнитель.</li>\n<li><b>2 - Podcaster</b>: Подкастер.</li>\n<li><b>3 - Preacher</b>: Проповедник.</li>\n<li><b>4 - Reader</b>: Чтец.</li>\n</ul>\n")).describe("Типы авторы"),
"church": z.string().describe("Церковь").nullable().nullish(),
"tracks": z.array(z.lazy(() => trackModelSchema)).describe("Треки, подкасты, проповеди и аудиокниги"),
"albums": z.array(z.lazy(() => albumModelSchema)).describe("Альбомы")
    })